import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main className="flex min-h-[78vh] items-center justify-center px-4 pb-16 pt-[120px]">
        <div className="w-full max-w-lg text-center">
          <p className="font-heading text-6xl font-semibold text-primary-500/70">404</p>
          <h1 className="mt-4 font-heading text-2xl text-foreground-950 md:text-3xl">
            这个页面走丢了
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            你访问的地址可能已经调整，或者链接输入有误。可以回到首页，或者直接去剧集库看看正在热播的剧。
          </p>
          <p className="mt-2 break-all font-label text-[11px] text-foreground-500">
            {location.pathname}
          </p>
          <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              返回首页
            </Link>
            <Link
              to="/category"
              className="cursor-pointer whitespace-nowrap rounded-md border border-background-300/60 px-4 py-2.5 font-label text-sm text-foreground-800 transition-colors hover:border-accent-500/60 hover:text-accent-600"
            >
              浏览电视剧分类
            </Link>
            <Link
              to="/search"
              className="cursor-pointer whitespace-nowrap rounded-md border border-background-300/60 px-4 py-2.5 font-label text-sm text-foreground-800 transition-colors hover:border-accent-500/60 hover:text-accent-600"
            >
              搜索剧集
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}